export const FALE_CONOSCO_TITLE = 'Como podemos te ajudar?';
export const FALE_CONOSCO_SUB_TITLE = 'Este é o seu canal de comunicação direta com o Acordo Seguro.';
export const FALE_CONOSCO_SUB_TITLE2 = 'Envie sua mensagem de forma rápida e fácil.';
